import React, { Component, Fragment } from 'react';

import { List, AutoSizer } from 'react-virtualized';
import { deepDiver } from 'helpers/utilities';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { AmenityStatus } from 'components/shared/StatusHelper';
import { getTranslatedString } from 'helpers/i18n';

const styles = {
  mobileCard: {
    height: 'calc(100% - 101px)',
    margin: '0 -15px',
  },
  tableHeader: {
    margin: '5px 0 0',
    fontSize: '15px',
    fontFamily: 'Circular-Black',
    color: AccentColor(),
  },
  emptyCard: {
    textAlign: 'center',
    color: 'rgba(0,0,0,0.5)',
    marginTop: '13px',
  },
};

class MobileAmenitiesTable extends Component {
  rowHeight = row => {
    if (row.tableHeader) return 35;
    return deepDiver(row, 'released_at') ? 128 : 106;
  };

  render() {
    if (this.props.data.length === 0) return this.renderEmpty();

    return (
      <Fragment>
        <div className="mobile_card" style={styles.mobileCard}>
          <AutoSizer>
            {({ height, width }) => (
              <List
                rowCount={this.props.data.length}
                rowHeight={({ index }) => this.rowHeight(this.props.data[index])}
                rowRenderer={({ key, index, style }, _data) =>
                  this.rowRenderer({ key, index, style }, this.props.data)}
                width={width}
                height={height}
              />
            )}
          </AutoSizer>
        </div>
      </Fragment>
    );
  }

  renderEmpty = () => (
    <div id="mobile_card">
      <div className="row">
        <p style={styles.emptyCard}>No amenities to view.</p>
      </div>
    </div>
  );

  rowRenderer = ({ key, index, style }, data) => {
    const amenities = data;
    const rowData = amenities[index];
    let rowStyle = { ...style, borderBottom: `1px solid ${colors.LIGHT_GRAY}` };

    if (rowData.tableHeader) return this.renderTableHeader(key, style, rowData.tableHeader);
    return (
      <div id="mobile_card" key={key} style={rowStyle}>
        <div className="row">
          <div className="mobile_subheader">
            <strong style={{ fontFamily: 'Circular' }}>{rowData.name}</strong>
            <div style={{ float: 'right' }}>
              <AmenityStatus amenity={rowData} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">{rowData.amenity_type_humanized}</div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            {rowData.max_booking_time}&nbsp;
            {getTranslatedString(
              `landlordPortal.amenities.time_unit.${rowData.time_unit.toLowerCase()}`
            )}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader">
            <button
              type="button"
              className="link-button"
              onClick={() => this.props.openAmenityInDrawer(rowData.id)}
            >
              {getTranslatedString('landlordPortal.amenities.mobileSubheader.viewDetails')}
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderTableHeader = (key, style, title) => {
    return (
      <div key={key} style={{ ...style, padding: '10px' }}>
        {' '}
        <h5 style={styles.tableHeader}>{title}</h5>{' '}
      </div>
    );
  };
}

export default MobileAmenitiesTable;
